import { useEffect, useState } from "react";
import { WaardelijstenApi } from "../../../api/waardelijsten";
import { Teksten } from "../../../content";
import { DropdownInfoFactory } from "../../../factories";
import { IdentifierWithChildren } from "../../../factories/waardelijst";
import { Identifier } from "../../../models";
import { useAppDispatch } from "../../../store/hooks";
import { unpublish } from "../../../store/reducers/document-metadata";
import { RequiredListValidator } from "../../../validations/requiredValidator";
import { PopupMolecule } from "../popup";
import { SelectDropdownMolecule } from "../select-dropdown";

interface Props {
  depublicerenId: string;
  hoofddocumentId?: string;
  close: () => void;
}

export function PopupDepublicerenDocumentMolecule(props: Readonly<Props>) {
  const dropdownInfofactory = new DropdownInfoFactory();
  const waardelijstFactory = new WaardelijstenApi();

  const [redenDepubliceren, setRedenDepubliceren] = useState<Identifier>();
  const [redenIntrekkingVervanging, setRedenIntrekkingVervanging] = useState<IdentifierWithChildren[]>([]);
  const dispatch = useAppDispatch();

  useEffect(() => {
    waardelijstFactory.getRedenIntrekkingVervanging().then(setRedenIntrekkingVervanging);
  }, []);

  const dropdownRedenDepubliceer = () => {
    const listValidations = [new RequiredListValidator()];

    return (
      <>
        <SelectDropdownMolecule
          onUpdated={(selectedIdentifier) => setRedenDepubliceren(selectedIdentifier)}
          selected={redenDepubliceren ? [redenDepubliceren] : []}
          key={Teksten.intrekken.document.id}
          tekst={Teksten.intrekken.document}
          categories={dropdownInfofactory.generateCheckboxListSelect(redenIntrekkingVervanging, redenDepubliceren)}
          singleSelect
          required
          search={false}
          validations={listValidations}
        />
        <p>Let op: als u een hoofddocument intrekt, dan worden ook alle bijlagen ingetrokken.</p>
      </>
    );
  };

  return (
    <PopupMolecule
      title={Teksten.intrekken.document.title}
      text={Teksten.intrekken.document.tekst}
      cancelButton={{
        text: "Annuleren",
        onClick: () => {
          props.close();
        },
      }}
      okeButton={{
        text: "Bevestigen",
        onClick: () => {
          if (redenDepubliceren) {
            dispatch(
              unpublish({
                id: props.depublicerenId,
                reden: redenDepubliceren.id,
                hoofddocumentId: props.hoofddocumentId,
              })
            );
            props.close();
          }
        },
      }}
      extraInfo={dropdownRedenDepubliceer()}
    />
  );
}
